import * as actions from "../redux/user";
import React, { Component } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";

import {
    PieChart,
    Settings,
    User
} from "react-feather";

import './User.css';
import auth from '../AuthService';

class UserComponent extends Component {
    componentDidMount() {
        this.props.getlogindata();
    }

    logout = e => {
        e.preventDefault();
        auth.getInstance().logout();
    }

    login = e => {
        e.preventDefault();
        auth.getInstance().login();
    }

    renderError = () => {
        this.props.assignNoPicture();
    }

    renderLogin() {
        return (<NavItem>
            <NavLink tag={Link} className="text-dark" to="/" onClick={this.login}>Login</NavLink>
        </NavItem>)
    }

    renderImage(user) {
        return this.props.noPicture || !user.picture ? <span className="user-no-pic">{user.name ? user.name[0] : null}</span> : <img src={user.picture} className="avatar img-fluid rounded-circle mr-1" alt={user.name} onError={this.renderError} />;
    }

    renderLogout(user) {
        return <UncontrolledDropdown nav inNavbar>
            <span className="d-inline-block d-sm-none">
                <DropdownToggle nav caret>
                    <Settings size={18} className="align-middle" />
                </DropdownToggle>
            </span>
            <span className="d-none d-sm-inline-block profile-wrapper">
                <DropdownToggle nav caret>
                    {this.renderImage(user)}
                    <span className="text-dark">{user.name}</span>
                </DropdownToggle>
            </span>
            <DropdownMenu right>
                <DropdownItem>
                    <User size={18} className="align-middle mr-2" />
                    Profile
              </DropdownItem>
                <DropdownItem>
                    <PieChart size={18} className="align-middle mr-2" />
                    Analytics
              </DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Settings & Privacy</DropdownItem>
                <DropdownItem>Help</DropdownItem>
                <DropdownItem onClick={this.logout}>Sign out</DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    }

    render() {
        return (this.props.name || (this.props.roles && this.props.roles.length > 0)) ? this.renderLogout(this.props) : this.renderLogin();
    }
}

const mapStateToProps = ({ user }) => ({
    name: user.name,
    picture: user.picture,
    roles: user.roles,
    noPicture: user.noPicture
});

export default connect(mapStateToProps, actions)(UserComponent);


// WEBPACK FOOTER //
// ./src/components/User.js